import { useQuery } from "@tanstack/react-query";
import { useMerchant } from "@/hooks/useMerchant";
import { useProtectTRPC } from "../trpc";

export function useFetchClaimsSummary() {
  const { merchant } = useMerchant();
  const trpc = useProtectTRPC();

  const { data, isPending } = useQuery({
    ...trpc.claims.summary.queryOptions({
      rentalsMerchantId: merchant?.id ?? "",
    }),
    enabled: !!merchant?.id,
  });

  return { summary: data, isLoading: isPending };
}
